var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6f757b",
    d: "M5.623 7.773l2.059 2.094a.316.316 0 0 0 .464 0L12.92 5l1.088 1.11.538.546-5.821 5.934a1.137 1.137 0 0 1-1.625 0L4.002 9.43l1.621-1.657zM18.001 9c0-4.963-4.038-9-9.002-9C4.039 0 .002 4.037.002 9c0 2.404.935 4.664 2.634 6.363a8.936 8.936 0 0 0 6.363 2.635c4.964 0 9.002-4.037 9.002-8.998z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDot);
export default __webpack_public_path__ + "static/media/check-dot.a4888c7406d8c0ff5c12842fe059a907.svg";
export { ForwardRef as ReactComponent };